import { createActionGroup, props } from '@ngrx/store';
import { SchemaSidProperty } from '@qtek/shared/models';

export const SchemaActions = createActionGroup({
  source: 'ProductSchema',
  events: {
    'Get Product Schema by query': props<{ payload: string }>(),
    'Get Product Schema by query Success': props<{
      payload: { view: any; query: string };
    }>(),
    'Get Product Schema by query Failure': props<{ payload?: any }>(),

    'Get SIDs Schema': props<{ payload: string[] }>(),
    'Get SID Schema Success': props<{
      payload: { [key: string]: SchemaSidProperty[] };
    }>(),
    'Get SID Schema Failure': props<{ payload?: any }>(),
  },
});
